import Image from 'next/image'
import Link from 'next/link'
import PropTypes from 'prop-types'

import SubHeader from 'components/SubHeader'

import { Main, Root, Tag, TagImage, TagImageBorder, TagImageWrapper, TagTitle } from './Tags.style'

const loader = ({ src, width, quality }) => {
  return `${src}&w=${width}&h=${width}&q=${quality || 75}&fit=crop`
}

const Tags = ({ tags, baseUrl = '/journal/tags' }) => {
  return (
    <Root>
      <Main>
        {tags.map(({ tag, imageUrl }) => (
          <Link key={tag} href={`${baseUrl}/${tag}`} passHref legacyBehavior>
            <Tag>
              <TagImageWrapper>
                <TagImageBorder height="48" width="48">
                  <circle cx="24" cy="24" r="23" strokeWidth="2" fillOpacity="0" />
                </TagImageBorder>
                <TagImage>
                  <Image
                    loader={loader}
                    width="48"
                    height="48"
                    src={imageUrl}
                    alt=""
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </TagImage>
              </TagImageWrapper>
              <TagTitle>
                <SubHeader>{tag}</SubHeader>
              </TagTitle>
            </Tag>
          </Link>
        ))}
      </Main>
    </Root>
  )
}

Tags.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      tag: PropTypes.string.isRequired,
      imageUrl: PropTypes.string.isRequired,
    })
  ),
}

Tags.defaultProps = {}

export default Tags
